import type { PoolOfferConfig } from '../../lib/api/operatorConsole';
import { LAB_DEMO_PACK, labDemoEnabled, needsLabDemo } from './labDemoPack';

interface PackSelectorProps {
  packs: PoolOfferConfig[];
  gameId: string;
  onGameIdChange: (id: string) => void;
  /** Suffix the packs that have their own opening animation. */
  markCustomOpening?: boolean;
}

const CUSTOM_OPENING_SUFFIX = ' · custom opening';

// Matches ConstructorTopBar's unified control style (h-7, px-3, font-mono 11px).
export function PackSelector({ packs, gameId, onGameIdChange, markCustomOpening = false }: PackSelectorProps) {
  return (
    <select
      value={gameId}
      onChange={(e) => onGameIdChange(e.target.value)}
      className="h-7 rounded border border-neutral-700 bg-neutral-900 px-3 font-mono text-[11px] text-white outline-none hover:bg-neutral-800"
    >
      <option value="">Select pack...</option>
      {packs.map((p) => (
        <option key={p.pool_offer_id} value={String(p.pool_offer_id)}>
          #{p.pool_offer_id} — {p.title ?? p.pool_offer_title}
          {markCustomOpening && p.animation ? CUSTOM_OPENING_SUFFIX : ''}
        </option>
      ))}
      {labDemoEnabled() && needsLabDemo(packs) && <option value={LAB_DEMO_PACK}>Custom pack lab — demo data</option>}
    </select>
  );
}
